import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
}
export function CTAButton({
  text = 'QUIERO RECUPERAR MI TIEMPO',
  className = '',
  fullWidth = false,
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    // Default behavior: smooth scroll to purchase section
    const purchaseSection = document.getElementById('purchase');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-gradient-to-r from-orange-500 to-red-600 
        text-white font-bold py-4 px-8 rounded-full 
        shadow-lg hover:shadow-xl transition-all duration-300
        flex items-center justify-center gap-2 text-lg uppercase tracking-wide
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-49">
      {text}
      <ArrowRight className="w-5 h-5" data-id="element-50" />
    </motion.button>;
}